import script from "./SelectObservationTypeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectObservationTypeFilter.vue?vue&type=script&setup=true&lang=js"

import "./SelectObservationTypeFilter.vue?vue&type=style&index=0&id=495f0dcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495f0dcd"]])

export default __exports__